<template>

    <form>

        <div class="form-group row mb-0">

            <div class="col">
                <compose-message-body v-model="sendBody"
                                      data-ui="reply-body"
                                      :error-model="errorModel"
                                      :cms-content-blocks="cmsComposeContentBlocks"
                                      :text-area-style-object="{ height: '200px !important' }"></compose-message-body>
            </div>
        </div>

        <div v-if="!disableUploads" class="form-group row mb-0">
            <div class="col">

                <upload-component :attachment-group-id="attachmentGroupId">
                    <template v-slot:multiple-error-slot>
                        <span class="invalid-feedback is-invalid d-inline">{{ errorModel.attachmentGroupId | firstError }}</span>
                    </template>
                </upload-component>

            </div>
        </div>

        <div class="form-group row mt-3">
            <div class="col">
                <button type="button" class="btn btn-primary" :disabled="isSendingMessage || isUploadingFile" @click="sendMessage" data-ui="reply-body-send-button">
                    <span v-if="isSendingMessage" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <div v-if="!isSendingMessage" class="d-inline">
                        <i class="far fa-paper-plane icon-button-w-text" aria-label="Send Message"></i>
                    </div>{{cmsComposeContentBlocks.sendMessage}}
                </button>

                <button type="button" class="btn btn-secondary" :disabled="isSendingMessage" @click="$emit('cancel')" data-ui="reply-body-cancel-button">
                    <i class="far fa-ban icon-button-w-text" aria-label="Cancel"></i>{{cmsComposeContentBlocks.cancel}}
                </button>
            </div>
        </div>

        <div class="form-group row">
            <div class="col-sm-12">
                <validation-summary-component :error-messages="errorModel"></validation-summary-component>
            </div>
        </div>
    </form>

</template>

<script>

    import Vue from 'vue';
    import { MessageHttpSvc } from '@SharedHttpServices/message.httpservice';
    import { IsModelStateError } from '@SharedServices/validation.service';
    import composeMessageBodyComponent from '../../../ComposeMessage/Components/Common/message.body.vue';

    import select2Component from '@SharedVueComponents/select2/select2.vue';
    import errorSummary from '@SharedVueComponents/Validation/ErrorSummary.vue';
    import uploadComponent from '@PortalVueComponents/Uploader/file.multiple.uploader.vue';
    import errorMessageDirective from '@SharedVueComponents/Validation/ErrorMessageDirective';

    export default {
        name: 'replyMessage',
        props: {
            toAddress: { type: String },
            subjectToUse: { type: String },
            replyToMessageId: { type: Number },
            attachmentGroupId: { type: String },
            cmsComposeContentBlocks: { type: Object },
            disableUploads: { type: Boolean, default: false }
        },
        components: {
            'select2-component': select2Component,
            'compose-message-body': composeMessageBodyComponent,
            'upload-component': uploadComponent,
            'validation-summary-component': errorSummary
        },
        data: function () {
            return {
                mode: 'Reply', //[Sent]

                isSendingMessage: false,
                isUploadingFile: false,

                sendBody: null,
                errorModel: {}
            }
        },
        watch: {

            subjectToUse: function (newValue, oldValue) {
                this.replyModel.subject = newValue;
            }
        },
        methods: {

            isUploading: function (isUploadingData) {
                this.isUploadingFile = isUploadingData;
            },

            sendMessage: function () {

                this.isSendingMessage = true;
                this.errorModel = {};

                MessageHttpSvc.ComposeMessageSendMessage('ReplyToMessage',
                    {
                        toAddress: this.toAddress,
                        subject: this.subjectToUse,
                        messageBody: this.sendBody,
                        replyToMessageId: this.replyToMessageId,
                        attachmentGroupId: this.attachmentGroupId
                    }
                ).done(response => {
                    //this.mode = 'Sent';
                    this.mode = 'Success';
                    this.$emit('messagesent', this.replyModel);
                }).fail((xhr, textStatus, obj) => {
                    if (IsModelStateError(xhr)) {
                        this.errorModel = xhr.responseJSON;
                        this.$emit('on-error-change', this.errorModel);
                        this.mode = 'Listing';
                    }
                }).always(x => {
                    this.isSendingMessage = false;
                });
            }

        }
    };
</script>

